module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"customerGroup":"Kundengruppe","orders":"Bestellungen","search":"Suchen…","siteId":"Marktnummer","siteName":"Markt","sites":"Märkte"},"en":{"customerGroup":"Customer group","orders":"Orders","search":"Search…","siteId":"Site id","siteName":"Site name","sites":"Sites"}}')
  delete Component.options._Ctor
}
